/**
 * Input types
 */
export var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
    InputType["NUMBER"] = "number";
    InputType["PASSWORD"] = "password";
    InputType["SEARCH"] = "search";
    InputType["DATE"] = "date";
    InputType["DATETIME_LOCAL"] = "datetime-local";
    InputType["EMAIL"] = "email";
})(InputType || (InputType = {}));
export var InputStatus;
(function (InputStatus) {
    InputStatus["SUCCESS"] = "success";
    InputStatus["WARNING"] = "warning";
    /** @deprecated use ERROR instead */
    InputStatus["DANGER"] = "danger";
    InputStatus["ERROR"] = "error";
    InputStatus["DEFAULT"] = "default";
})(InputStatus || (InputStatus = {}));
export var InputKeyboardAppearance;
(function (InputKeyboardAppearance) {
    InputKeyboardAppearance["DEFAULT"] = "default";
    InputKeyboardAppearance["LIGHT"] = "light";
    InputKeyboardAppearance["DARK"] = "dark";
})(InputKeyboardAppearance || (InputKeyboardAppearance = {}));
export var InputAutoCapitalize;
(function (InputAutoCapitalize) {
    InputAutoCapitalize["NONE"] = "none";
    InputAutoCapitalize["SENTENCES"] = "sentences";
    InputAutoCapitalize["WORDS"] = "words";
    InputAutoCapitalize["CHARACTERS"] = "characters";
})(InputAutoCapitalize || (InputAutoCapitalize = {}));
/**
 * Specifies autocomplete hints for the system, so it can provide autofill.
 *
 * @see {@link https://reactnative.dev/docs/next/textinput#autocomplete}
 */
export var InputAutoCompleteType;
(function (InputAutoCompleteType) {
    InputAutoCompleteType["ADDITIONAL_NAME"] = "additional-name";
    InputAutoCompleteType["ADDRESS_LINE1"] = "address-line1";
    InputAutoCompleteType["ADDRESS_LINE2"] = "address-line2";
    /** iOS 17+ */
    InputAutoCompleteType["CC_CSC"] = "cc-csc";
    /** iOS 17+ */
    InputAutoCompleteType["CC_EXP"] = "cc-exp";
    /** iOS 17+ */
    InputAutoCompleteType["CC_EXP_DAY"] = "cc-exp-day";
    /** iOS 17+ */
    InputAutoCompleteType["CC_EXP_MONTH"] = "cc-exp-month";
    /** iOS 17+ */
    InputAutoCompleteType["CC_EXP_YEAR"] = "cc-exp-year";
    InputAutoCompleteType["CC_NUMBER"] = "cc-number";
    InputAutoCompleteType["COUNTRY"] = "country";
    InputAutoCompleteType["CURRENT_PASSWORD"] = "current-password";
    InputAutoCompleteType["EMAIL"] = "email";
    InputAutoCompleteType["FAMILY_NAME"] = "family-name";
    InputAutoCompleteType["GIVEN_NAME"] = "given-name";
    InputAutoCompleteType["HONORIFIX_PREFIX"] = "honorific-prefix";
    InputAutoCompleteType["HONORIFIC_SUFFIX"] = "honorific-suffix";
    InputAutoCompleteType["NAME"] = "name";
    InputAutoCompleteType["NEW_PASSWORD"] = "new-password";
    InputAutoCompleteType["OFF"] = "off";
    InputAutoCompleteType["ONE_TIME_CODE"] = "one-time-code";
    InputAutoCompleteType["POSTAL_CODE"] = "postal-code";
    InputAutoCompleteType["STREET_ADDRESS"] = "street-address";
    InputAutoCompleteType["TEL"] = "tel";
    InputAutoCompleteType["USERNAME"] = "username";
    /** iOS only / iOS 17+ */
    InputAutoCompleteType["CC_FAMILY_NAME"] = "cc-family-name";
    /** iOS only / iOS 17+ */
    InputAutoCompleteType["CC_GIVEN_NAME"] = "cc-given-name";
    /** iOS only / iOS 17+ */
    InputAutoCompleteType["CC_MIDDLE_NAME"] = "cc-middle-name";
    /** iOS only / iOS 17+ */
    InputAutoCompleteType["CC_NAME"] = "cc-name";
    /** iOS only / iOS 17+ */
    InputAutoCompleteType["CC_TYPE"] = "cc-type";
    /** iOS only */
    InputAutoCompleteType["NICKNAME"] = "nickname";
    /** iOS only */
    InputAutoCompleteType["ORGANIZATION"] = "organization";
    /** iOS only */
    InputAutoCompleteType["ORGANIZATION_TITLE"] = "organization-title";
    /** iOS only */
    InputAutoCompleteType["URL"] = "url";
    /** Android only */
    InputAutoCompleteType["GENDER"] = "gender";
    /** Android only */
    InputAutoCompleteType["NAME_FAMILY"] = "name-family";
    /** Android only */
    InputAutoCompleteType["NAME_GIVEN"] = "name-given";
    /** Android only */
    InputAutoCompleteType["NAME_MIDDLE"] = "name-middle";
    /** Android only */
    InputAutoCompleteType["NAME_MIDDLE_INITIAL"] = "name-middle-initial";
    /** Android only */
    InputAutoCompleteType["NAME_PREFIX"] = "name-prefix";
    /** Android only */
    InputAutoCompleteType["NAME_SUFFIX"] = "name-suffix";
    /**
     * Android only
     * @deprecated Prefer using 'current-password'
     **/
    InputAutoCompleteType["PASSWORD"] = "password";
    /**
     * Android only
     * @deprecated Prefer using 'new-password'
     **/
    InputAutoCompleteType["PASSWORD_NEW"] = "password-new";
    /** Android only */
    InputAutoCompleteType["POSTAL_ADDRESS"] = "postal-address";
    /**
     * Android only
     * @deprecated Prefer using 'country'
     **/
    InputAutoCompleteType["POSTAL_ADDRESS_COUNTRY"] = "postal-address-country";
    /** Android only */
    InputAutoCompleteType["POSTAL_ADDRESS_EXTENDED"] = "postal-address-extended";
    /** Android only */
    InputAutoCompleteType["POSTAL_ADDRESS_EXTENDED_POSTAL_CODE"] = "postal-address-extended-postal-code";
    /** Android only */
    InputAutoCompleteType["POSTAL_ADDRESS_LOCALITY"] = "postal-address-locality";
    /** Android only */
    InputAutoCompleteType["POSTAL_ADDRESS_REGION"] = "postal-address-region";
    /** Android only */
    InputAutoCompleteType["SMS_OTP"] = "sms-otp";
    /** Android only */
    InputAutoCompleteType["TEL_COUNTRY_CODE"] = "tel-country-code";
    /** Android only */
    InputAutoCompleteType["TEL_DEVICE"] = "tel-device";
    /** Android only */
    InputAutoCompleteType["TEL_NATIONAL"] = "tel-national";
    /** Android only */
    InputAutoCompleteType["USERNAME_NEW"] = "username-new";
})(InputAutoCompleteType || (InputAutoCompleteType = {}));
export var InputTextContentType;
(function (InputTextContentType) {
    InputTextContentType["NONE"] = "none";
    InputTextContentType["URL"] = "URL";
    InputTextContentType["ADDRESS_CITY"] = "addressCity";
    InputTextContentType["ADDRESS_CITY_STATE"] = "addressCityAndState";
    InputTextContentType["ADDRESS_STATE"] = "addressState";
    InputTextContentType["COUNTRY_NAME"] = "countryName";
    InputTextContentType["CREDIT_CARD_NUMBER"] = "creditCardNumber";
    InputTextContentType["EMAIL_ADDRESS"] = "emailAddress";
    InputTextContentType["FAMILY_NAME"] = "familyName";
    InputTextContentType["FULL_STREET_ADDRESS"] = "fullStreetAddress";
    InputTextContentType["GIVEN_NAME"] = "givenName";
    InputTextContentType["JOB_TITLE"] = "jobTitle";
    InputTextContentType["LOCATION"] = "location";
    InputTextContentType["MIDDLE_NAME"] = "middleName";
    InputTextContentType["NAME"] = "name";
    InputTextContentType["NAME_PREFIX"] = "namePrefix";
    InputTextContentType["NAME_SUFFIX"] = "nameSuffix";
    InputTextContentType["NICKNAME"] = "nickname";
    InputTextContentType["ORGANIZATION_NAME"] = "organizationName";
    InputTextContentType["POSTAL_CODE"] = "postalCode";
    InputTextContentType["STREET_ADDRESS_LINE_ONE"] = "streetAddressLine1";
    InputTextContentType["STREET_ADDRESS_LINE_TWO"] = "streetAddressLine2";
    InputTextContentType["SUB_LOCALITY"] = "sublocality";
    InputTextContentType["TELEPHONE_NUMBER"] = "telephoneNumber";
    InputTextContentType["USERNAME"] = "username";
    InputTextContentType["PASSWORD"] = "password";
    InputTextContentType["NEW_PASSWORD"] = "newPassword";
    InputTextContentType["ONE_TIME_CODE"] = "oneTimeCode";
})(InputTextContentType || (InputTextContentType = {}));
export var InputKeyboardType;
(function (InputKeyboardType) {
    InputKeyboardType["DEFAULT"] = "default";
    InputKeyboardType["EMAIL_ADDRESS"] = "email-address";
    InputKeyboardType["NUMERIC"] = "numeric";
    InputKeyboardType["PHONE_PAD"] = "phone-pad";
    InputKeyboardType["NUMBER_PAD"] = "number-pad";
    InputKeyboardType["DECIMAL_PAD"] = "decimal-pad";
    InputKeyboardType["VISIBLE_PASSWORD"] = "visible-password";
    InputKeyboardType["ASCII_CAPABLE"] = "ascii-capable";
    InputKeyboardType["NUMBERS_AND_PUNCTUATION"] = "numbers-and-punctuation";
    InputKeyboardType["URL"] = "url";
    InputKeyboardType["NAME_PHONE_PAD"] = "name-phone-pad";
    InputKeyboardType["TWITTER"] = "twitter";
    InputKeyboardType["WEB_SEARCH"] = "web-search";
})(InputKeyboardType || (InputKeyboardType = {}));
//# sourceMappingURL=data:application/json;base64,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